import type { DecisionEventType } from "./decisionEventTypes";
import type { DemoRuleCategory, DemoRuleScope } from "./ruleTypes";
import type { RuleCapabilitySet } from "./ruleCapabilities";
import type { RuleRoutingConfig } from "./ruleRouting";

export type RuleIntegrationStatus = "native_appglue" | "adapter_backed" | "demo_only";

export type RuleEditorSurface =
    | "native_appglue_editor"
    | "native_rule_table_builder"
    | "native_value_table_builder"
    | "native_text_merge_builder"
    | "adapter_summary"
    | "none";

export type RuleExecutableFamily = "statement_rule" | "rule_table" | "value_table" | "text_merge" | "demo_only";

export type RuleCatalogEntry = {
    id: string;
    title: string;
    category: DemoRuleCategory;
    scope: DemoRuleScope;
    trigger: DecisionEventType;
    sourceTable: string;
    executableFamily: RuleExecutableFamily;
    targetAppGlueObjectLabel: string;
    inputSchemaId?: string;
    rowMapperId?: string;
    evaluationPolicyId?: string;
    routingPolicyId?: string;
    summaryPolicyId?: string;
    demoProjectionPolicyId?: string;
    appGlueStorageSeed?: object;
    capabilities: RuleCapabilitySet;
};

export type RuleInstance = {
    id: string;
    catalogEntryId: string;
    displayOrder: number;
    enabled: boolean;
    title: string;
    appGlueStorageData?: object;
    routingConfig?: RuleRoutingConfig;
};

export const isIntegratedStatus = (
    status: RuleIntegrationStatus,
): status is Exclude<RuleIntegrationStatus, "demo_only"> => status === "native_appglue" || status === "adapter_backed";

export const describeRuleIntegrationStatus = (status: RuleIntegrationStatus): string => {
    if (status === "native_appglue") return "Native AppGlue";
    if (status === "adapter_backed") return "Adapter-backed";
    return "Demo-only";
};
